import React, { useEffect, useRef, useState } from "react";

/**
 * If we have div in the middle of the screen.
 * It will make it take the reminder space from to go all the way down to the bottom of the screen
 */


export function DivAutoSizeFromHereToBottom({ children }) {
  var ref = useRef(null);
  var [myHeight,set_myHeight]=useState(0)
  useEffect(()=>{
    set_myHeight (ref.current ? window.innerHeight - ref.current.offsetTop : 0)
  },[])
  return <div ref={ref} css={`height:${myHeight}px;`}>{children}</div>
}
